import { isHandyApp } from "./device";

let sequenceId = 0;

// 创建专门的 JSON 修复函数
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJSONParse(jsonString: string): any {
  // 修复常见的转义问题
  const fixedString = jsonString
    // 修复无效的反斜杠转义（更精确的正则）
    .replace(/\\(?![\\/"bfnrtu]|u[0-9a-fA-F]{4})/g, "\\\\")
    // 移除可能的控制字符

    .replace(/[\x00-\x1F\x7F]/g, "")
    // 修复可能的尾随逗号
    .replace(/,(\s*[}\]])/g, "$1");

  try {
    const result = JSON.parse(fixedString);
    console.log("JSON 修复成功");
    return result;
  } catch (fixError) {
    console.error("JSON 修复失败:", fixError);
    return {
      sequence_id: "",
    };
  }
}

export type PostCommandOptions = {
  needResponse: boolean;
};

type PostCommandRes = TokenProps & appLoginStatus & UserPromptResponse;

const nextSeqId = () => (sequenceId += 1).toString();
function postCommand(
  commandName: string,
  req: RequestUserTokenFromAppProps | null,
  options: PostCommandOptions = { needResponse: false },
): Promise<PostCommandRes> {
  if (!isHandyApp()) {
    if (process.env.NODE_ENV === "development") {
      return Promise.reject("develop env not support");
    } else {
      return Promise.resolve({} as PostCommandRes);
    }
  }
  const { needResponse } = options;

  return new Promise((resolve) => {
    const seqId = nextSeqId();

    const commandReq = {
      sequence_id: seqId,
      command: commandName,
      data: req,
    };
    const handleResponse = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) {
        return;
      }
      let obj = event.data;
      if (event.data && typeof event.data === "string") {
        // 处理字符串格式的 JSON
        try {
          obj = JSON.parse(obj);
        } catch {
          // 如果解析失败，可能是因为数据不是 JSON 格式
          console.error("Failed to parse JSON from message:", obj);
          obj = safeJSONParse(obj);
        }
      }
      if (obj.sequence_id !== seqId) {
        return;
      }

      resolve(obj.response);
      window.removeEventListener("message", handleResponse);
    };

    if (needResponse) {
      window.addEventListener("message", handleResponse);
    } else {
      resolve({} as PostCommandRes);
    }
    window.wx?.postMessage(JSON.stringify(commandReq));
  });
}

// 1    登录成功
// 2    取消登录
// 3    不需要调起APP情况下未获取到token
export interface appLoginStatus {
  status?: "1" | "2" | "3";
}
export type TokenProps = {
  /**  access token */
  accessToken: string;
  /**  refresh token */
  refreshToken: string;
  /**  access token 有效时长 */
  expiresIn: number;
  /**  refresh token 有效时长 */
  refreshExpiresIn: number;
};
export interface UserPrompt {
  /** 机型 */
  printerModel?: string;
  /** code和文案 */
  hms?: string;
  /** handy lan */
  handyLan?: string;
}
interface UserPromptResponse extends UserPrompt {
  hmsList?: UserPrompt[];
  question: string;
  answer?: string;
}
interface RequestUserTokenFromAppProps {
  shouldLogin?: number;
  jumpUrl?: string;
}
// web 从 app 取 token
export function requestUserTokenFromApp(
  props: RequestUserTokenFromAppProps,
): Promise<TokenProps & appLoginStatus> {
  return postCommand("request_user_token_from_app", props, {
    needResponse: true,
  });
}

// web 从 app 取 hms 机型 语言 等信息
export function requestUserPromptFromApp(): Promise<UserPromptResponse> {
  return postCommand("request_user_prompt_from_app", null, {
    needResponse: true,
  });
}

// web 通知app 打开（跳转）浏览器
export function openBrowser(jumpUrl: string): Promise<PostCommandRes> {
  return postCommand(
    "jump_external_browser",
    { jumpUrl },
    {
      needResponse: false,
    },
  );
}

export const requireTicket = async (accessToken: string) => {
  const apiUrl = `/v1/user-service/user/ticket`;
  const bambulabOrigin = `${process.env.NEXT_PUBLIC_PORTAL_API_HOST}`;
  try {
    const fetchResponse = await fetch(`${bambulabOrigin}${apiUrl}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Cache-Control": "no-cache",
      },
    });
    const result = await fetchResponse.json();
    return result;
  } catch (error) {
    throw new Error(`requireTicket: ${String(error)}`);
  }
};

export const requireUserInfo = async (
  accessToken: string,
  bambulabOrigin: string,
) => {
  const apiUrl = `/v1/user-service/my/profile`;
  try {
    const fetchResponse = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "Cache-Control": "no-cache",
      },
    });
    const result = await fetchResponse.json(); // Correctly parsing once
    return result;
  } catch (error) {
    throw new Error(`requireUserInfo: ${String(error)}`);
  }
};

// confirm ticket
export const confirmTicket = async (ticket: string, accessToken: string) => {
  const apiUrl = `/v1/user-service/my/ticket/${ticket}`;
  try {
    const fetchResponse = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const result = await fetchResponse.json();
    return result;
  } catch (error) {
    throw new Error(`confirmTicket: ${String(error)}`);
  }
};
